import React from 'react';

export const ZipComponentModal = ({ descargados, totales, porcentaje }) => {
	return (
		<div
			style={{
				backgroundColor: '#f4f4f4',
				borderRadius: '8px',
				width: '40%',
				padding: '3px',
				paddingLeft:"4px",
				paddingRight:"4px"
			}}
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-start',
					gap: '8px',
					marginBottom: '4px',
				}}
			>
				<div
					style={{
						width: '16px',
						height: '16px',
						border: '2px solid #3699FF',
						borderTop: '2px solid transparent',
						borderRadius: '50%',
						animation: 'spin 1s linear infinite',
					}}
				></div>
				<span
					style={{
						fontSize: '14px',
						color: '#6b7280',
					}}
				>
					Descargando...
				</span>
			</div>

			<div
				style={{
					width: '100%',
					height: '6px',
					backgroundColor: '#e5e7eb',
					borderRadius: '4px',
					overflow: 'hidden',
				}}
			>
				<div
					style={{
						width: `${porcentaje}%`,
						height: '100%',
						backgroundColor: '#3699FF',
						transition: 'width 0.3s ease-in-out',
					}}
				></div>
			</div>

			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					marginTop: '6px',
					fontSize: '12px',
					color: '#6b7280',
				}}
			>
				<span>{porcentaje}%</span>
				<span>
					{descargados}/{totales} archivos
				</span>
			</div>
		</div>
	);
};
